// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","393":"b688dc31","447":"220f1dcc","455":"55372804","946":"65568695","967":"cfefdebe"}[chunkId] + ".chunk.js";
};